module.exports = "/images/vendor/flag-icon-css/flags/4x3/na.svg?bb49a4035c384be9926bac6004bea21f";